/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_Removed_SuccessInputs */



/**
* | output |
* | --- |
* | "List removed successfully" |
*
* @param {List_Removed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const list_removed_success = /** @type {((inputs?: List_Removed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_Removed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste supprimée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Liste erfolgreich entfernt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco rimosso con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список успешно удален")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista eliminada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("列表已成功移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リストが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची सफलतापूर्वक हटा दी गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista removida com sucesso")
	return /** @type {LocalizedString} */ ("List removed successfully")
});